'use es6';

import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { device } from '../../../constants/StyledComponentConstants';
const ModalTile = styled(UITile).withConfig({
  displayName: "ModalTile",
  componentId: "ebaraj-0"
})(["border:none;border-radius:0;"]);
export const ModalTileSection = styled(UITileSection).withConfig({
  displayName: "ModalTile__ModalTileSection",
  componentId: "ebaraj-1"
})(["@media screen and ", "{padding-left:12px;padding-right:12px;}"], device.mobile);
export default ModalTile;